import { createUseStyles } from "react-jss";
import { ITheme } from "../../../constants/theme";
import {
  BreakPointDesktop,
  BreakPointMobile,
  BreakPointTablet,
} from "../../../constants/dimension";

export const useStyles = createUseStyles((theme: ITheme) => ({
  root: {
    textAlign: "center",
    [BreakPointDesktop]: {
      width: "40%",
      textAlign: "initial",
    },
  },
  canvasAnimate: {
    position: "fixed",
    inset: 0,
    width: "100%",
    height: "100%",
    pointerEvents: "none",
    zIndex: theme.zIndex.normal,
    willChange: "transform",
    transform: "translateZ(0)",
  },
  title: {
    fontWeight: "500 !important",
    marginTop: theme.spacing.space16,
    marginBottom: theme.spacing.space24,
    lineHeight: "120% !important",
  },
  box: {
    background: "rgba(255, 255, 255, 0.05)",
    borderRadius: theme.radius.medium,
    padding: theme.spacing.space16,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: theme.spacing.space16,
    position: "relative",
    border: `2px solid ${theme.colors.TextDefault}`,
    [BreakPointTablet]: {
      backdropFilter: "blur(10px)",
    },
    [BreakPointMobile]: {
      backdropFilter: "blur(10px)",
    },
  },
  boxGradient: {
    border: "none",
    "&:before": {
      content: `""`,
      position: "absolute",
      inset: 0,
      padding: theme.spacing.space2,
      borderRadius: theme.radius.medium,
      background: "linear-gradient(170deg, #1A569F, #FFFFFF)",
      "-webkit-mask":
        "linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)",
      "-webkit-mask-composite": "xor",
      maskComposite: "exclude",
      pointerEvents: "none",
    },
  },
  access: {
    color: "#D1D1D1 !important",
    textAlign: "center",
  },
  date: {
    marginTop: theme.spacing.space8,
    marginBottom: theme.spacing.space8,
  },
  goBtn: {
    background: "#166CD6",
    marginTop: theme.spacing.space24,
    height: 50,
    borderRadius: theme.radius.small,
    fontSize: 16,
    fontWeight: 600,
    "&.linearBg": {
      background: "linear-gradient(275deg, #4786D3 4.58%, #17529B 89.48%)",
    },
    [BreakPointDesktop]: {
      height: 57,
      fontSize: 20,
      marginTop: 60,
      minWidth: 294,
    },
  },
  gift: {
    width: 80,
    height: 80,
  },
  desc: {
    color: "#E8E8E8 !important",
  },
}));
